import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowCircleBrokenDownLeft = function ArrowCircleBrokenDownLeft(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9.0002 9v6.0001m0 0h6m-6 0 9.9998-10m2.6606 4.4104c.8909 3.3362.0278 7.0433-2.5895 9.6606-3.9053 3.9053-10.237 3.9053-14.1422 0-3.9052-3.9052-3.9052-10.2369 0-14.1421 2.6173-2.6173 6.3245-3.4805 9.6607-2.5896"
    })
  }));
};
export default ArrowCircleBrokenDownLeft;